import React from 'react';
import AdminLayout from '../../../../Components/CommonComponents/Layout/adminLayout';
import UserFormContainer from '../../../../Containers/AdminContainer/Users/UserForm';
const UserFormScreen = () => {
  return <UserFormContainer />;
};

export default UserFormScreen;
